import angular from 'angular';
import salesComponent from './sales.component';
import SalesService from './sales.service';
import salesConfig from './sales.config';

let salesModule = angular.module('sales',[])
  .component('sales', salesComponent)
  .service('SalesService', SalesService)
  .config(salesConfig);

export default salesModule;



// WEBPACK FOOTER //
// ./www/components/catalog/sales/sales.js